import {remCalc} from '../../_utils'

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        drawerBody: {
            px: {base: 'xsmall-1.base', md: 'medium-1.md'},
            pt: {base: 'xsmall-1.base', md: 'small.md'},
            pb: {base: 'xsmall-1.base', md: 'small.md'},
        },
        drawerHeader: {
            paddingY: 'xsmall.base',
            paddingX: 'xsmall-1.base',
            background: 'background.base.default',
            position: 'relative',
            height: remCalc(56),
            minHeight: remCalc(56),
            maxHeight: remCalc(56),
        },
        drawerContent: {
            bg: 'background.base.default',
        },
        breadcrumbContainer: {gap: remCalc(10), align: 'center'},
        breadcrumbText: {
            textStyle: 'body-small',
            fontWeight: 'normal',
            lineHeight: 'unset',
        },
        firstLevelGrid: {
            gap: {base: remCalc(24), md: remCalc(32)},
            pt: {base: remCalc(21), md: remCalc(16)},
        },
        firstLevelSecondaryGrid: {
            columns: 2,
            gap: {base: remCalc(8), sm: remCalc(16), md: remCalc(24)},
        },
        headerLinks: {gap: {base: remCalc(8), sm: remCalc(16), md: remCalc(24)}},
        headerIconSize: {boxSize: 'iconsSize.small'},
        svgContainer: {
            h: 'xsmall-1.base',
            w: 'xsmall-1.base',
            alignItems: 'center',
            justifyContent: 'center',
        },
        secondaryCardsGrid: {gap: {base: remCalc(8), sm: remCalc(16), md: remCalc(24)}},
        secondLevelContainer: {
            pt: {base: remCalc(21)},
            maxW: 'container.xxl',
            m: 'auto',
            direction: 'column',
        },
        secondLevelExploreAll: {
            borderRadius: 'full',
            w: '100%',
            mb: {base: remCalc(24), md: remCalc(32)},
        },
        secondLevelGrid: {gap: remCalc(24)},
    },
    parts: ['drawerBody'],
}
